import { getMessages } from '../../../../../../../store/constants';

export const COMMENTS_CHAT_TOOLTIP_JOIN = getMessages().getText('card_form_section_comments_chat_tooltip.join');
export const COMMENTS_CHAT_TOOLTIP_LEAVE = getMessages().getText('card_form_section_comments_chat_tooltip.leave');

export enum COMMENTS_ORDER_LABEL {
    ASC = 'Show newest first',
    DESC = 'Show oldest first'
}
